/**
 * PHI-safe logging contract (architecture §5.5 — encoded in the door API,
 * not tribal knowledge):
 *
 * 1. Message bodies MUST NOT carry PHI. Log identifiers and error codes, not
 *    patient content — same policy the Rust side enforces
 *    (docs/CODE_REVIEW_GUIDELINE_RUST.md, "no PHI in messages"). Given the
 *    scope caveats on rule 2, this rule is the primary protection today,
 *    not a nicety.
 * 2. Scope of this redact list (pre-existing behavior, preserved verbatim by
 *    the ARCFE-676 move): it is wired into the pino instance only, so it
 *    applies to pino's own output where the Node build of pino runs (SSR,
 *    Jest) — pino's browser build ignores `redact` entirely. The Datadog
 *    transmit path (`sendToDatadog`) receives the raw message/context and
 *    does NOT pass this list; it applies only the credential scrub in
 *    ./scrub-credentials (auth headers, cookies, bearer/JWT strings).
 *    TODO(ARCFE-679): apply this redact list to the Datadog egress path —
 *    the one path that leaves the device — then restore the "every record
 *    passes this list" guarantee here.
 * 3. Extending the list is additive-only: removing or narrowing a path is a
 *    privacy-policy change, not a refactor — flag it in review.
 */
export const pinoRedactedPaths = [
  'data.*.id',
  'data.*.email',
  'data.*.phone',
  'data.*.first_name',
  'data.*.last_name',
  'data.*.birth_date',
  'data.*.demographic_string',
  'data.*.ehr_patient_id',
  'kinde_gp_id',
  'patient.name',
  'patient.dob',
  'patient_profile.birth_date',
  'patient_profile.first_name',
  'patient_profile.last_name',
  'patient_profile.demographic_string',
  'birth_date',
  'first_name',
  'last_name',
  'demographic_string',
  'name',
  'patient.demographic_details',
  'ehr_patient_id',
  'ehr_appt_id',
  'ehr_encounter_id',
  'patient_profile',
  '*.password',
  '*.token',
  '*.secret',
];
